import {createContext, useContext} from "react";
import {PosOrderEdit} from "@/data/entities/order";

/**
 * The order being edited, or `null` when placing a new order.
 */
export type ExistingOrder = PosOrderEdit & {
    publicCartId: string,
};

const ExistingOrderContext = createContext<ExistingOrder | null>(null);

export const ExistingOrderProvider = ExistingOrderContext.Provider;

/**
 * The order being edited in the order editor, or `null` for a new order.
 */
export const useExistingOrder = (): ExistingOrder | null => useContext(ExistingOrderContext);